import { render, staticRenderFns } from "./ClientParent.vue?vue&type=template&id=078f6697&"
import script from "./ClientParent.vue?vue&type=script&lang=js&"
export * from "./ClientParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports